import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href && href.startsWith('http')) {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
      window.location.href = href;
    } else if (href) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.();
  };
  return <motion.button onClick={handleClick} className={`${`
        relative inline-flex items-center justify-center
        px-8 py-4 
        bg-teal text-cream font-body font-medium text-lg
        rounded-lg
        transition-colors duration-300
        focus:outline-none focus:ring-2 focus:ring-teal-light focus:ring-offset-2 focus:ring-offset-deep
        ${className}
      `} text-[24px]`} whileHover={{
    scale: 1.03,
    boxShadow: '0 0 30px rgba(45, 138, 138, 0.4), 0 0 60px rgba(45, 138, 138, 0.15)',
    backgroundColor: '#3da5a5'
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.25,
    ease: 'easeOut'
  }} data-id="element-98">
      {children}
    </motion.button>;
}